import { gridSizeMdLg4, gridSizeMdLg3, formatDate } from "@/shared"
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm"
import DateRangePicker from "@/shared/components/ui/CustomSearch/DateRangePicker"
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch"
import { IDataProducto } from "@/shared/interfaces"
import { IDataSerie } from "@/shared/interfaces/erp/administration/productofactorserie.interface"
import { FilterAltOff } from "@mui/icons-material"
import { Grid, IconButton, Tooltip } from "@mui/material"
import { useRef } from "react"
import Flatpickr from 'react-flatpickr';
import { UseFormReturn } from "react-hook-form"
import { FieldValues } from "react-hook-form"

type TransferenciaInventarioFiltroProps<T extends FieldValues> = {
  form: UseFormReturn<T, any, undefined>
}
export const TransferenciaInventarioFiltro = <T extends FieldValues,>({
  form
}: TransferenciaInventarioFiltroProps<T>) => {
  const flatpickrRef = useRef<Flatpickr>(null);

  const {
    fetchAutocompleteProducto,
    fetchAutocompleteSerie
  } = useAutocompleteFetch()

  const { control, reset } = form

  return (
    <Grid
      item
      container
      spacing={2}
      xs={12}
      justifyContent="space-between"
      alignItems="center"
    >

      <CustomAutocompleteFetchForm<IDataProducto>
        control={control}
        required={false}
        size={gridSizeMdLg4}
        name="descripcion_producto"
        label="Buscar por Descripcion"
        fetchData={fetchAutocompleteProducto}
        keySearch="descripcion"
        getOptionLabel={(opt) => `${opt.descripcion}` || ''}
        key={'autocomplete-producto'}
        getOptionKey={(opt) => opt.codigo}
        onChangeValue={(e) => {
          reset({
            ...form.getValues(),
            producto_codigo: e as string
          })
        }}

      />

      <CustomAutocompleteFetchForm<IDataSerie>
        required={false}
        control={control}
        size={gridSizeMdLg4}
        name="serie"
        label="Buscar por Serie o MAC"
        fetchData={fetchAutocompleteSerie}
        //isAll={true}
        getOptionLabel={(opt) => opt.serie || ''}
        key={'autocomplete-serie'}
        getOptionKey={(o) => o.serie!}
        keySearch="serie"
        onChangeValue={(e) => {
          //setEnabled(false);

          reset({
            ...form.getValues(),
            producto_serie: e as string
          })


        }}
      />

      <DateRangePicker
        size={gridSizeMdLg3}
        flatpickrRef={flatpickrRef}
        defaultValue={[form.getValues().fecha_creacion_after, form.getValues().fecha_creacion_before]}
        onChange={(range) => {
          //console.log(range);
          //setEnabled(false);

          if (range.length == 2) {
            reset({
              ...form.getValues(),
              fecha_creacion_after: formatDate(range[0]),
              fecha_creacion_before: formatDate(range[1])
            })

          }

        }}
      />

      <Grid item xs={1}>
        <Tooltip title="Limpiar filtros">
          <IconButton
            onClick={() => {
              console.log('Limpiar filtros');
              reset({
                fecha_creacion_before: undefined,
                fecha_creacion_after: undefined,
                producto_codigo: undefined,
                producto_serie: undefined
              } as any)
            }}>
            <FilterAltOff />
          </IconButton>
        </Tooltip>

      </Grid>
    </Grid>
  )
}